<template>
    <div class="import_bj">
       <div class="w">
           <div class="import_title">导入问卷</div>
           <ul class="import_box">
               <li class="flex space-between">
                   <p>1.点击下载模板，将问卷模板下载到本地</p>
                   <div>
                       <el-button type="primary" plain @click="downLoad">下载模板</el-button>
                   </div>
               </li>
               <li class="flex space-between">
                   <p>2.点击导入问卷，自动生成问卷</p>
                   <div>
                       <!--<el-button type="primary">导入问卷</el-button>-->
                       <!--<input type="file" class="fileInput" value="导入问卷">-->
                       <a href="javascript:;" class="file">
                           导入问卷
                           <input type="file" name="" id="" @change="importFile">
                       </a>
                   </div>
               </li>
           </ul>
       </div>
    </div>
</template>

<script>
    export default {
        name: "Import",
        data(){
          return {
              token:''
          }
        },
        methods:{
            language() {
                return window.localStorage.getItem('lang') || this.$defaultLang
            },
            downLoad(){
                let a = document.createElement("a");
                a.href = "/导入模板.xls";
                a.download = "导入模板.xls";
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                a.remove();
            },
            importFile(event){
                // 上传文件
                console.log(event);
                let file = event.target.files[0]
                let formData = new FormData()
                formData.append("multipartFile",file)
                console.log(formData.get("uploadFile"));
                let that = this;

                that.$axios({
                    url:this.$config.service.importQuestionnaire,
                    method:"POST",
                    data:formData,
                    headers: {
                        "Content-Type":'multipart/form-data',
                        Authorization : "Bearer "+that.token,
                        'Accept-Language': this.language(),
                    },
                }).then((res)=>{
                    if (res.data.code == 0) {
                        that.$message.success("导入成功");
                        that.$router.push({path:"/my"})
                    }else {
                        that.$message.error('导入失败，请重新导入');
                    }
                })

                // let params = {
                //     url:this.$config.service.importQuestionnaire,
                //     method:"POST",
                //     data:{
                //         multipartFile:file
                //     },
                //     headers: {
                //         ctype:'multipart/form-data'
                //     },
                //     that:this,
                //     cb(res){
                //         if (res.code == 0) {
                //            that.$message.success("导入成功");
                //            that.$router.push({path:"/my"})
                //         }else {
                //             that.$message.error('导入失败，请重新导入');
                //         }
                //     }
                // }
                // that.$util.request(params)
            }
        },
        created() {
            this.token =  window.localStorage.getItem('token');
        }
    }
</script>

<style scoped>
 .import_bj{
     width: 100%;
     height: 100%;
     background: #f5f5f5;
     position: absolute;
 }
.import_title{
    font-size: 16px;
    margin-top: 20px;
}
    .import_box{
        width: 100%;
        min-height: 150px;
        border: 1px solid #ccc;
        background: #fff;
        margin-top: 20px;
    }
    .import_box li{
        padding: 0 30px;
        margin-top: 20px;
    }
 .file {
     position: relative;
     display: inline-block;
     background: #D0EEFF;
     border: 1px solid #99D3F5;
     border-radius: 4px;
     padding: 9px 21px;
     overflow: hidden;
     color: #1E88C7;
     text-decoration: none;
     text-indent: 0;
     line-height: 20px;
     font-size: 14px;
 }
 .file input {
     position: absolute;
     font-size: 100px;
     right: 0;
     top: 0;
     opacity: 0;
 }
 .file:hover {
     background: #AADFFD;
     border-color: #78C3F3;
     color: #004974;
     text-decoration: none;
 }
    
</style>